<template>
	<v-text-field
		:label="field.Name"
		v-model="value"
		hide-details
	></v-text-field>
</template>
<script>
export default {
	name: 'ActivityItemStaticField',
	props: {
		field: Object,
		index: Number,
		activityItem: Object,
	},
	data() {
		return {
			value: '',
		};
	},
	mounted() {
		if (
			this.activityItem.StaticFields.length > 0 &&
			this.activityItem.StaticFields[this.index]
		)
			this.value = this.activityItem.StaticFields[this.index].Value;
	},
	watch: {
		value(newVal) {
			let param = {
				ActivityStaticFieldId: this.field.Id,
				Value: newVal,
			};
			this.$emit('change', param, this.index);
		},
	},
};
</script>
